import React from 'react';
import { ContentContainer, Description, Content, Space } from './aboutElements';

const About = () => {
  return (
    <div>
      <ContentContainer>
        <Description>
          <Content>Jonathan Root is not just a name. “When I started photographing designers, architects and artists I became more aware of, and interested in, mid-century design, so I started buying pieces.
            “There’s a mix of contemporary and mid-century here, which I think works well. Some of my favourite pieces include the first edition Eames lounger, the 1965 Egg chair and the mahogany Ladderax system.
            “Cameras are great too; they’re beautiful. I think one of my cameras was designed by the same guy who designed the green De Tomaso Mangusta sports car that I used to have. I love that when you start looking into design, it’s all connected.
            “There are some older objects too. I’ve got a lobster-tailed pot helmet from the Civil War. The shape of it is so modern. Ideas of Modernism has been around for a long, long time; it’s not something that is 50 or 100 years old.
            “This building used to be part of the Chappell Piano factory, which was the largest in Europe. The original Victorian factory is opposite, and I helped save it from being knocked down. It’s now on a list of important industrial buildings in Camden.</Content>
        </Description>
        <Space>
        </Space>

        <Description>
          <img src='/images/about/Photographer-Jonathan-Root-retro-interiors-8-950x1425.webp' alt='Photographer Jonathan Root retro interiors' />
          <p>Jonathan Root - Chalk Farm, London</p>
        </Description>


      </ContentContainer>




    </div>
  );
};

export default About;